import React, {useState} from 'react';
import { Typography, List, ListItemButton, ListItemText, Modal, Box, CircularProgress, Divider } from '@mui/material';


const ListaOrdenes = ({ ordenes }) => {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [modalOpen, setModalOpen] = useState(false);
    const [detalleEncuesta, setDetalleEncuesta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorCarga, setErrorCarga] = useState(null);


    const handleClickOrden = async (orden) => {
    
      try{

       setDetalleEncuesta(null); // Limpia datos anteriores
    setErrorCarga(null);
    setModalOpen(true); // Abre el modal inmediatamente
    setLoading(true);
        const idEncuestaEnviada = orden.idEncuestaEnviada;

          if (!idEncuestaEnviada) {
          throw new Error('ID de encuesta enviada no está definido.');
        }

        const response = await fetch(`${server}/CrmEncuestaEnviadums/detalle-encuesta-encuestaEnviada/${idEncuestaEnviada}`);

        if (!response.ok) {
          throw new Error('Error al obtener los datos');
        }
        
        const data = await response.json();
        // console.log(data);
        setDetalleEncuesta(data);
        setModalOpen(true);
      } catch (error) {
        console.error('Error al cargar detalles de la encuesta:', error);
      } finally {
        setLoading(false);
      }

    };

    const handleClose = () => {
      setModalOpen(false);
      setDetalleEncuesta(null);
    };
    

    if (!ordenes || ordenes.length === 0) {
        return <Typography>No hay órdenes disponibles.</Typography>;
    }

  return (
    <>
    <List dense disablePadding>
      {ordenes.map((orden, index) => (
        <ListItemButton
          key={index}
          onClick={() => handleClickOrden(orden)}
          sx={{
            borderBottom: '1px solid #eee',
            padding: '6px 12px',
          }}
        >
          <ListItemText
            primary={orden.idOrden ? `Orden: ${orden.idOrden}` : 'Encuesta Anónima'}
            primaryTypographyProps={{
              sx: {
                color: '#1976d2',
                fontWeight: 500,
                cursor: 'pointer',
              },
            }}
          />
        </ListItemButton>
      ))}
    </List>

    {/* Modal que se abre al hacer clic en una orden */}
      <Modal open={modalOpen} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: 800,
            bgcolor: 'background.paper',
            // border: '2px solid #1976d2',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxHeight: '80vh',
            overflowY: 'auto',
          }}
        >
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
            </Box>
          ) : errorCarga ? (
             <Typography color="error">{errorCarga}</Typography>
          ) : detalleEncuesta ? (
            <>
          
          <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 600, mb: 2 }}>
            {detalleEncuesta.encuesta.titulo}
          </Typography>

          <Divider sx={{ mb: 2 }} />

            {detalleEncuesta.orden && (
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Orden:</strong> {detalleEncuesta.orden.idOrdenMedica}
          </Typography>
            )}

          {detalleEncuesta.nombreCompleto && (
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Cliente:</strong> {detalleEncuesta.nombreCompleto}
          </Typography>
          )}

          {detalleEncuesta.numeroIdentidad && (
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Número de identidad:</strong> {detalleEncuesta.numeroIdentidad}
          </Typography>
          )}

          {detalleEncuesta.orden?.ingresadoPor &&(
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Ingresada por:</strong> {detalleEncuesta.orden.ingresadoPor}
          </Typography>
          )}

          {detalleEncuesta.orden?.fechaIngreso &&(
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Fecha de creacion de orden:</strong> {new Date(detalleEncuesta.orden.fechaIngreso).toLocaleString()}
          </Typography>
          )}

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
            Respuestas
          </Typography>
          {Array.isArray(detalleEncuesta.encuesta.preguntas?.$values) &&
        detalleEncuesta.encuesta.preguntas.$values.length > 0 ? (
          <List dense disablePadding>
            {/* {Array.isArray(detalleEncuesta.encuesta.preguntas?.$values) && */}
            {detalleEncuesta.encuesta.preguntas.$values.map((pregunta) => {
              const respuesta = detalleEncuesta.respuestas?.$values?.find(
                (r) => r.idPregunta === pregunta.idPregunta
              );

              return (
                 <Box key={pregunta.idPregunta} sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 500 }}> {pregunta.textoPregunta} </Typography>
                  <Box sx={{ pl: 2, mt: 1 }}>
                    {respuesta ? (
                      <>
                        {respuesta.textoRespuesta && (
                          <Typography variant="body2" sx={{ mb: 0.5 }}> 
                            <strong>Respuesta:</strong> {respuesta.textoRespuesta}
                          </Typography>)}
                        
                        {respuesta.valorNumerico != null && (
                          <Typography variant="body2" sx={{ mb: 0.5 }}> 
                            <strong>Escala:</strong> {respuesta.valorNumerico}
                          </Typography>
                        )}
                        
                        {respuesta.siONo != null && (
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            <strong>Respuesta:</strong> {respuesta.siONo ? 'Si' : 'No'}
                          </Typography>
                        )}
                        
                        {respuesta.opcionesSeleccionadas?.$values?.length > 0 && (
                      //     <div>
                      //       Opciones seleccionadas: {''}
                      //   {respuesta.opcionesSeleccionadas.$values.map((opt, idx) => (
                      //     <span key={idx}>
                      //       {opt.textoOpcion}
                      //       {idx < respuesta.opcionesSeleccionadas.$values.length -1 ? ', ' : ''}
                      //     </span>
                      //   ))}
                      // </div>
                       <Typography variant="body2" sx={{ mb: 0.5 }}>
                              <strong>Opciones seleccionadas:</strong>{' '}
                              {respuesta.opcionesSeleccionadas.$values
                                .map((opt) => opt.textoOpcion)
                                .join(', ')}
                            </Typography>
                    )}
                    </>
                    ) : (
                     <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                          No hay respuesta registrada.
                     </Typography>
                    )}
                  </Box>
                   <Divider sx={{ mt: 2 }} />
                </Box>
              );
            })}
          </List>
         ) : (
                   <Typography>
                     No se encontraron preguntas para esta encuesta.
                   </Typography>
                 )}
</>
          ):(
             <Typography>Error al cargar detalles.</Typography>
          )}
          
        </Box>
      </Modal>
    </>
  );
};

export default ListaOrdenes;